module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/stretchlab-e3dfc1236dddf2f1197ef9ed903786ed.png";